import { ServiceType } from '../constants/ServiceConstants';
export function getEnvironment() {
    var _a;
    const origin = (_a = window.location.host) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    switch (origin) {
        case 'alpha.uipath.com': return 'alp';
        case 'staging.uipath.com': return 'stg';
        case 'cloud.uipath.com': return 'prd';
        case 'alpha.gov.uipath-dev.com': return 'agov';
        case 'staging.gov.uipath-dev.com': return 'sgov';
        case 'govcloud.uipath.us': return 'pgov';
    }
    if (isLocal()) {
        if (origin === null || origin === void 0 ? void 0 : origin.includes('localhost:5000')) {
            return 'integration-test';
        }
        if (origin === null || origin === void 0 ? void 0 : origin.includes('localhost:44351')) {
            return 'local-msi';
        }
        return 'local';
    }
    return isMSI() ? 'msi' : 'k8s';
}
export function getEnvironmentDomain(env = getEnvironment()) {
    switch (env) {
        case 'local':
        case 'integration-test':
            return 'localhost';
        case 'alp':
        case 'stg':
        case 'prd':
            return '.uipath.com';
        case 'agov':
        case 'sgov':
            return '.gov.uipath-dev.com';
        case 'pgov':
            return '.uipath.us';
        default:
            return undefined;
    }
}
export function isMSI() {
    var _a;
    const services = Object.values(ServiceType).map(name => name.toLowerCase());
    const pathName = (_a = window.location.pathname) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    if (pathName === null || pathName === void 0 ? void 0 : pathName.startsWith('/identity_')) {
        return false;
    }
    for (let i = 0; i < services.length; i++) {
        const name = services[i];
        if ((pathName === null || pathName === void 0 ? void 0 : pathName.indexOf(`/${name}_/`)) > -1 || (pathName === null || pathName === void 0 ? void 0 : pathName.endsWith(`/${name}_`))) {
            return false;
        }
    }
    // This will include both MSI and isStandalone cases
    return true;
}
export function isLocal() {
    var _a;
    const origin = (_a = window.location.host) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    return (origin === null || origin === void 0 ? void 0 : origin.includes('localhost'))
        || (origin === null || origin === void 0 ? void 0 : origin.includes('local:'))
        || origin === 'st-aks-sw-we-tm.trafficmanager.net';
}
